module.exports = __webpack_public_path__ + "img/viber-popup.c47856cb.svg";